"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ClearIndicator;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _reactSelect = require("react-select");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    closeIcon: {
      height: theme.spacing(2),
      width: theme.spacing(2)
    }
  };
});
function ClearIndicator(props) {
  // eslint-disable-next-line react/prop-types
  var innerProps = props.innerProps,
    selectProps = props.selectProps;
  var classes = useStyles();
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/prop-types
    _react["default"].createElement(_reactSelect.components.ClearIndicator, (0, _extends2["default"])({}, props, {
      innerProps: _objectSpread({}, innerProps, {
        'data-metrics': selectProps.dataMetrics.clearIndicator
      })
    }), /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      className: classes.closeIcon,
      color: "secondary",
      fontSize: "small"
    }))
  );
}